module.exports = __webpack_public_path__ + "static/media/ousbxxs7ohhddd3wz18k.96ad5232.png";